import routerOptions0 from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.13.1_@types+node@22.13.10_eslint@8.57.0_rollup@4.36.0_sass@1.77.8_typescript@5.4.5_vue-tsc@2.0.12/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}